import axios from 'axios';
import { ApiResponse, zps_wp } from '../zps';

export type IPeriod = {
  amountPayAP: number;
  amountPayCash: number;
  period: number;
};

export type ISafe = {
  amountBills: number;
  amountCoins: number;
  bills: number;
  coins: number;
};

export type IRecycler = {
  bills: number[];
  coins: number[];
};

export type IDashboardEquipment = {
  cid: number;
  description: string;
  eid: number;
  entid: number;
  period?: IPeriod;
  recyclers?: IRecycler;
  safe?: ISafe;
  sid: number;
  state: number;
  totalAmount: number;
  equiType: number;
};

export interface IDashboardResponse extends ApiResponse {
  equipments: IDashboardEquipment[];
}

export const fetchDashboardInfo = (entid: number, sid: number): Promise<IDashboardResponse> => {
  const url = `${zps_wp}/api/dashboard/equipment/list?entid=${entid}&sid=${sid}`;

  return axios.get<IDashboardResponse>(url).then(res => res.data);
};
